export default "__VITE_ASSET__DiRVU7yO__"